// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__8Cqpf","rootSuccess":"CompleteLink_rootSuccess__3qycx","rootFailure":"CompleteLink_rootFailure__hQ5Ke","isDisabled":"CompleteLink_isDisabled__2IS7z"};